abstract class Storage {
  static separator: string;

  static get: (key: string) => string | null;

  static set: (key: string, value: string, expires?: Date) => void;

  static remove: (key: string) => void;
}

export default Storage;
